import React from 'react';
import AnimationToggle from 'styles/blocks/question/animationControl';

export function AnimationControl({ isAnimationDisabled, onToggleAnimation }) {
  return isAnimationDisabled ? (
    <AnimationToggle>
      <AnimationToggle.Text>Screen animation is disabled. </AnimationToggle.Text>
      <AnimationToggle.Button type="button" onClick={() => onToggleAnimation()}>Turn on animation</AnimationToggle.Button>
    </AnimationToggle>
  ) : (
    <AnimationToggle>
      <AnimationToggle.Text>This form uses screen animation. </AnimationToggle.Text>
      <AnimationToggle.Button type="button" onClick={() => onToggleAnimation()}>Turn off animation</AnimationToggle.Button>
    </AnimationToggle>
  );
}
